import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GenesysIframeModule } from '../genesys-iframe/genesys-iframe.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { GenesysIntegrationPanelComponent } from './genesys-integration-panel.component';

@NgModule({
  imports: [
    SvgIconModule,
    TranslateModule,
    GenesysIframeModule
  ],
  declarations: [
    GenesysIntegrationPanelComponent
  ],
  exports: [
    GenesysIntegrationPanelComponent
  ]
})
export class GenesysIntegrationPanelModule {}
